const SPLASH_ID = "app-splash";
// Matches the opacity transition on #app-splash in index.html.
const FADE_MS = 150;

/**
 * Fades out and removes the static splash index.html paints before the bundle loads. Called once
 * the first route has rendered, so nothing shows between the splash and that page.
 */
export function hideSplash(): void {
    const splash = document.getElementById(SPLASH_ID);
    if (!splash) return;

    splash.classList.add("app-splash--done");
    setTimeout(() => splash.remove(), FADE_MS);
}
